/* Utilismo · estilo Kalles — "Leve junto" + Comprar agora / Adicionar ao carrinho */
(function () {
  'use strict';

  function fmt(c, moeda) {
    try { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: moeda || 'BRL' }); }
    catch (e) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
  }

  function iniciar(box) {
    if (box._kl) return;
    box._kl = 1;
    var sec = box.closest('.shopify-section') || document;
    var moeda = box.getAttribute('data-moeda') || 'BRL';
    var vars = {};
    try { vars = JSON.parse(box.querySelector('[data-kl-variantes]').textContent); } catch (e) {}

    var check = box.querySelector('[data-kl-extra-check]');
    var extraVar = box.querySelector('[data-kl-extra-var]');
    var extraPreco = box.querySelector('[data-kl-extra-preco]');
    var extraBox = box.querySelector('.kl-compra__extra');
    var bAgora = box.querySelector('[data-kl-agora]');
    var bCar = box.querySelector('[data-kl-carrinho]');
    var tAgora = box.querySelector('[data-kl-agora-txt]');
    var tCar = box.querySelector('[data-kl-carrinho-txt]');
    var totalEl = box.querySelector('[data-kl-total]');
    var erro = box.querySelector('[data-kl-erro]');

    function idAtual() {
      var i = sec.querySelector('form[action*="/cart/add"] input[name="id"]');
      return i && i.value ? String(i.value) : Object.keys(vars)[0];
    }
    function qtd() {
      var q = sec.querySelector('input[name="quantity"]');
      return Math.max(1, parseInt(q && q.value, 10) || 1);
    }
    function extraInfo() {
      if (!extraVar) return null;
      var el = extraVar.tagName === 'SELECT' ? extraVar.options[extraVar.selectedIndex] : extraVar;
      if (!el) return null;
      return { id: Number(el.value), p: Number(el.getAttribute('data-p')) || 0, de: Number(el.getAttribute('data-de')) || 0 };
    }
    function marcado() { return !!(check && check.checked); }

    function atualizar() {
      var v = vars[idAtual()] || { p: 0, ok: false };
      var ex = extraInfo();
      var tot = v.p * qtd() + (marcado() && ex ? ex.p : 0);
      if (totalEl) { totalEl.textContent = ' · ' + fmt(tot, moeda); totalEl.hidden = !v.ok; }
      if (bAgora && !bAgora.classList.contains('is-carregando')) {
        bAgora.disabled = !v.ok;
        if (tAgora) tAgora.textContent = v.ok ? 'Comprar agora' : 'Esgotado';
      }
      if (bCar && !bCar.classList.contains('is-carregando')) bCar.disabled = !v.ok;
      if (ex && extraPreco) {
        var html = '+ ' + fmt(ex.p, moeda);
        if (ex.de > ex.p) html += ' no lugar de ' + fmt(ex.de, moeda) + ' · <b>economize ' + fmt(ex.de - ex.p, moeda) + '</b>';
        extraPreco.innerHTML = html;
      }
      if (extraBox) extraBox.classList.toggle('is-marcado', marcado());
    }

    function itens() {
      var lista = [{ id: Number(idAtual()), quantity: qtd() }];
      var ex = extraInfo();
      if (marcado() && ex && ex.id) lista.push({ id: ex.id, quantity: 1 });
      return lista;
    }
    function mostrarErro(m) {
      if (!erro) return;
      erro.textContent = m || '';
      erro.hidden = !m;
    }
    function carregando(b, t, on, txt) {
      if (!b) return;
      b.classList.toggle('is-carregando', on);
      b.disabled = on;
      b.setAttribute('aria-busy', on ? 'true' : 'false');
      if (t) {
        if (on) { t._txt = t.textContent; t.textContent = txt; }
        else if (t._txt) { t.textContent = t._txt; }
      }
      if (b === bAgora && totalEl) totalEl.hidden = on;
      if (!on) atualizar();
    }
    function adicionar(comGaveta) {
      var cart = comGaveta ? (document.querySelector('cart-drawer') || document.querySelector('cart-notification')) : null;
      var body = { items: itens() };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && !res.items) throw new Error(res.description || res.message || 'Não foi possível adicionar.');
          try { document.dispatchEvent(new CustomEvent('fsb:product:added', { detail: res })); } catch (e) {}
          return { res: res, cart: cart };
        });
    }

    if (bCar) {
      bCar.addEventListener('click', function () {
        if (bCar.disabled) return;
        mostrarErro('');
        carregando(bCar, tCar, true, 'Adicionando…');
        adicionar(true)
          .then(function (o) {
            carregando(bCar, tCar, false);
            if (o.cart && typeof o.cart.renderContents === 'function' && o.res.sections) {
              var inner = o.cart.querySelector('.drawer__inner');
              if (inner) inner.classList.remove('is-empty');
              o.cart.classList.remove('is-empty');
              try { o.cart.renderContents(o.res); } catch (e) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function (e) {
            carregando(bCar, tCar, false);
            mostrarErro(e && e.message ? e.message : 'Não foi possível adicionar.');
          });
      });
    }

    if (bAgora) {
      bAgora.addEventListener('click', function () {
        if (bAgora.disabled) return;
        mostrarErro('');
        carregando(bAgora, tAgora, true, 'Indo para o pagamento…');
        adicionar(false)
          .then(function () {
            if (typeof window.yampiClick === 'function') {
              window.yampiClick();
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
            setTimeout(function () { carregando(bAgora, tAgora, false); }, 8000);
          })
          .catch(function (e) {
            carregando(bAgora, tAgora, false);
            mostrarErro(e && e.message ? e.message : 'Não foi possível adicionar.');
          });
      });
    }

    if (check) check.addEventListener('change', atualizar);
    if (extraVar) extraVar.addEventListener('change', atualizar);
    if (extraBox && check) {
      extraBox.addEventListener('click', function (e) {
        if (e.target.closest('input, select, label, a, option')) return;
        check.checked = !check.checked;
        atualizar();
      });
    }
    sec.addEventListener('change', function () { setTimeout(atualizar, 30); });
    sec.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') atualizar(); });
    sec.addEventListener('click', function (e) { if (e.target.closest('.quantity__button')) setTimeout(atualizar, 30); });
    window.addEventListener('pageshow', function () {
      [[bAgora, tAgora], [bCar, tCar]].forEach(function (p) { if (p[0] && p[0].classList.contains('is-carregando')) carregando(p[0], p[1], false); });
    });
    atualizar();
  }

  function todos(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-kl-compra]'), iniciar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { todos(); });
  else todos();
  document.addEventListener('shopify:section:load', function (e) { todos(e.target); });
})();
